export default __webpack_public_path__ + "static/epica-3-d3a09c742542907f0d10a68861396838.jpg";